import '@daxko/ui-components/dist/default/ui-components-lib-wc.js';
import '@daxko/ui-components/dist/default/ui-components-fonts.css';
import '@daxko/ui-components/dist/default/ui-components-icons.css';

class CaUnifiedAlert extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({mode: 'open'});
        this.message = this.getAttribute('message');
        this.title = this.getAttribute('title');
        this.variant = this.getAttribute('variant');
        this.rounded = this.getAttribute('rounded');
        this.showCloseButton = this.getAttribute('showCloseButton');
        this.showExternalLink = this.getAttribute('showExternalLink');
        this.externalText = this.getAttribute('externalText');
    }

    connectedCallback() {
        this.render();
    }

    render() {
        this.shadowRoot.innerHTML = `
        <style>
        .alert-external-text{
            color: #4597F7;
            font-size: 14px;
            font-family: Barlow, sans-serif;
            line-height: 16px;
            margin-left: 4px;
        }
        </style>
        <dc-banner 
            message='${this.message ? this.message : ''}'
            banner-title='${this.title}' 
            variant='${this.variant}' ${this.rounded ? 'rounded' : ''}
            showCloseButton='${this.showCloseButton ? this.showCloseButton : ''}'
            showExternalLink='${this.showExternalLink ? this.showExternalLink : ''}'>
            <div class="alert-external-text">${this.externalText}</div>
        </dc-banner>
    `;
    }
}

customElements.define("ca-unified-alert", CaUnifiedAlert);
